import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';

import * as MaintenanceReducer from "@app/maintenance/store/maintenance.reducer"
import { AddActivityAction, LoadActivitiesAction, UpdateActivitiesAction } from '@app/maintenance/store/maintenance.actions';
import { Activity } from '@app/shared/models/activity.model';

import { ActivityModalComponent } from '@app/maintenance/components/activity-modal/activity-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleService } from '@app/core/services/role.service';
import { TranslateService } from '@ngx-translate/core';
import { map } from "rxjs/operators";
import * as _ from "lodash";

@Component({
    selector: 'app-tool-maintenance-activities',
    templateUrl: './tool-maintenance-activities.component.html',
    styleUrls: ['./tool-maintenance-activities.component.scss']
})
export class ToolMaintenanceActivitiesComponent implements OnInit, OnDestroy {
    @ViewChild(ActivityModalComponent, {static: false}) createModal: ActivityModalComponent;

    activities = [];
    selectedActivity: Activity;
    searchQuery = '';
    roles = [];

    loading$: Observable<any>;
    activities$: Observable<any>;
    createdActivity$: Observable<any>;
    deletedActivityId$: Observable<any>;

    activitiesSubscription: Subscription;
    createdActivitySubscription: Subscription;
    deletedActivityIdSubscription: Subscription;

    constructor(
        private store: Store<any>,
        private roleService: RoleService,
        private route: ActivatedRoute,
        private router: Router,
        private translate: TranslateService
    ) {
        this.loading$ = this.store.pipe(select(MaintenanceReducer.isLoading), map(loading => _.cloneDeep(loading)));
        this.activities$ = this.store.pipe(select(MaintenanceReducer.getActivities), map(activities => _.cloneDeep(activities)));
        this.createdActivity$ = this.store.pipe(select(MaintenanceReducer.getCreatedActivity), map(createdActivity => _.cloneDeep(createdActivity)));
        this.deletedActivityId$ = this.store.pipe(select(MaintenanceReducer.getDeletedActivityId),  map(deletedActivity => _.cloneDeep(deletedActivity)));

        this.activitiesSubscription = this.activities$.subscribe(activities => {
            if (activities) {
                this.activities = activities.items;
            }
        });

        this.createdActivitySubscription = this.createdActivity$.subscribe(activity => {
            if (activity) {
                this.store.dispatch(new LoadActivitiesAction(this.searchQuery));
            }
        });

        this.deletedActivityIdSubscription = this.deletedActivityId$.subscribe(id => {
            if (id) {
                this.store.dispatch(new LoadActivitiesAction(this.searchQuery));
            }
        });

        roleService.getAllRoles().subscribe(roles => this.roles = roles.items);
    }

    ngOnInit() {
        this.store.dispatch(new LoadActivitiesAction());
        this.roleService.getAllRoles().subscribe(roles => this.roles = roles.items);
    }

    openActivityModal() {
        this.createModal.open();
    }

    onSearch(event: string) {
        this.searchQuery = event;
        this.store.dispatch(new LoadActivitiesAction(event));
    }

    onSelectActivity(event: Activity) {
        this.selectedActivity = event;
        this.router.navigate([`${event.id}/details`], {relativeTo: this.route});
    }

    onCreate(event: any) {
        this.createModal.close();
        this.store.dispatch(new AddActivityAction(event));
    }

    get adaptRoles() {
        return this.roles.map(role => new Object({
            id: role.id,
            icon: "fa fa-user",
            title: role.name,
            subtitle: this.translate.instant(
                `admin.toolMaintenancePlans.activities.modal.${role.isOob ? 'implicitRole' : 'personalizedRole'}`
            ),
            showAssign: true
        }));
    }

    onActivityReorder() {
        this.activities.forEach((activity, index) => {
            activity.priority = index + 1;
        });

        this.store.dispatch(new UpdateActivitiesAction(this.activities));
    }

    ngOnDestroy(): void {
        if (this.activitiesSubscription) {
            this.activitiesSubscription.unsubscribe();
        }

        if (this.createdActivitySubscription) {
            this.createdActivitySubscription.unsubscribe();
        }

        if (this.deletedActivityIdSubscription) {
            this.deletedActivityIdSubscription.unsubscribe();
        }
    }
}
